import { AppIntegrationsRepository } from 'common/repositories/index';
import { AppIntegrationsProcessor } from 'common/repositoryProcessors/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

const _directiveDependencies = ['Templates'];
const _controllerDependencies = ['$scope', '$state', '$window', 'Util', 'DeploymentUrlsRestService'];

class PaidDeploymentWizardController {

    constructor($scope, $state, $window, Util, DeploymentUrlsRestService) {

        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.Util = Util;
        this.AppIntegrationsProcessor = AppIntegrationsProcessor;
        this.DeploymentUrlsRestService = DeploymentUrlsRestService;
        $scope.imgPath = CWCONFIG.imgPath;

        /* this array can contain paid apps, bundles and apps from bundles.
        e.g. [ {id: asu60, licenseId: 233312-356397, type: 'apps', oeName: 'Antivirus'} ] */
        this.allPaidApps = [];

        this.licenses = this.$scope.inputData.licenses;

        $scope.osDefaultAppId = CWCONFIG.defaultDeployedAppId[$scope.inputData.os];
        $scope.appIntegrations = {};
        $scope.osDefaultIntegration = AppIntegrationsRepository.getById($scope.osDefaultAppId);
        $scope.showFreeApp = true;
        this.$scope.isMobileDeploy = false;

        const selectedOS = this.$scope.inputData.os;
        this.componentsUsefulInfo = {};

        // If user has a paid license, hide FSS
        if (this.licenses.length > 0) {

            $scope.showFreeApp = false;

        }

        if (this.$state.current.name.indexOf('.home') > -1) {

            this.page = 'Homepage';

        } else if (this.$state.current.name.indexOf('.devices') > -1) {

            this.page = 'Devices';

        } else if (this.$state.current.name.indexOf('.products') > -1) {

            this.page = 'Products';

        } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

            this.page = 'Subscriptions';

        }

        this.licenses.forEach((license) => {

            const appId = Util.deepFind(license, 'relationships.app.data.id');
            const appIntegration = AppIntegrationsRepository.getById(appId);
            const appType = Util.deepFind(appIntegration, 'attributes.type');
            const appIntegrationOSes = Util.deepFind(appIntegration, 'attributes.custom.manifest.os') || ['windows'];

            if (appIntegration) {

                /* here we iterate through all bundle apps
                and add them into 'allPaidApps' array only if
                the selected operating system is "android" or "ios" */
                if (appType === 'bundle' && (selectedOS === 'android' || selectedOS === 'ios')) {

                    this.$scope.isMobileDeploy = true;

                    appIntegration.relationships.apps.data.forEach((bundleAppIntegration) => {

                        const bundleAppData =
                            AppIntegrationsRepository.getById(bundleAppIntegration.id);

                        if (bundleAppData) {

                            const bundleAppOSes = Util.deepFind(bundleAppData, 'attributes.custom.manifest.os') || ['windows'];

                            // check if the bundle app OS is compatible
                            // with the selected OS "$scope.inputData.os"
                            if (_.contains(bundleAppOSes, $scope.inputData.os)) {

                                // save app information (name, icon etc...)
                                // into "$scope.appIntegrations" object
                                if (!$scope.appIntegrations[bundleAppIntegration.id]) {

                                    $scope.appIntegrations[bundleAppIntegration.id] = bundleAppData;

                                }

                                // check if the app already exists in "allPaidApps" array
                                const isAppDuplicated =
                                    this.allPaidApps.find(app => app.id ===
                                        bundleAppIntegration.id);

                                // if the app doesn't exists in "allPaidApps" array, push the app
                                if (!isAppDuplicated) {

                                    this.allPaidApps.push({
                                        id: bundleAppIntegration.id,
                                        licenseId: license.id,
                                        type: bundleAppIntegration.type,
                                        oeName: bundleAppData.attributes.resource.oeName,
                                    });

                                    this.componentsUsefulInfo[bundleAppIntegration.id] = {
                                        is_beta_otc: license.attributes.is_beta_otc,
                                    };

                                }

                            }

                        }

                    });

                }

                /* here we add all the bundles and standalone apps into 'allPaidApps' array after
                we check if the app OSes are compatible with the selected OS '$scope.inputData.os'
                */
                if (_.contains(appIntegrationOSes, $scope.inputData.os)) {

                    /* here we check if we show the default free app for the selected OS
                        OS default free app prototype and paid apps prototype must be the same
                    */
                    if (appType === 'bundle') {

                        appIntegration.relationships.apps.data.forEach((bundleAppIntegration) => {

                            const bundleAppData =
                                AppIntegrationsRepository.getById(bundleAppIntegration.id);

                            if (bundleAppData) {

                                const bundleAppOSes = Util.deepFind(bundleAppData, 'attributes.custom.manifest.os') || ['windows'];

                                // check if the bundle app OS is compatible
                                // with the selected OS "$scope.inputData.os"
                                if (_.contains(bundleAppOSes, $scope.inputData.os)) {

                                    if (
                                        bundleAppData.attributes.prototype ===
                                        $scope.osDefaultIntegration.attributes.prototype
                                    ) {

                                        $scope.showFreeApp = false;

                                    }

                                }

                            }

                        });

                    }

                    // save information regarding the the app (name, icon etc...)
                    // into "$scope.appIntegrations" object
                    if (appIntegration.id && !$scope.appIntegrations[appIntegration.id]) {

                        $scope.appIntegrations[appIntegration.id] =
                            AppIntegrationsRepository.getById(appIntegration.id);

                    }

                    // check if the app already exists in "allPaidApps" array
                    const isAppDuplicated =
                        this.allPaidApps.find(app => app.id === appIntegration.id);

                    // check if the app has been split into components
                    const appIntegrationHasBeenSplit =
                        this.allPaidApps
                            .find((app) => {

                                if (appIntegration.relationships.apps) {

                                    return appIntegration.relationships.apps.data
                                        .find(appInt => appInt.id === app.id);

                                }

                                return false;

                            });

                    // if the app doesn't exists in "allPaidApps" array &
                    // if the app has now been split into individual components, push to allPaidApps
                    if (!isAppDuplicated && !appIntegrationHasBeenSplit) {

                        this.allPaidApps.push({
                            id: appIntegration.id,
                            licenseId: license.id,
                            type: appType,
                            trueBundle:
                                this.AppIntegrationsProcessor.checkIfTrueBundle(
                                    appIntegration,
                                    $scope.inputData.os,
                                ),
                            oeName: appIntegration.attributes.resource.oeName,
                            // browsers: appIntegration.attributes.custom.manifest.browsers
                        });

                    }

                }

            }

            // If the user has already Prime or a single license,
            // skip the select license step
            if (
                ((appId === 'aps10' || appId === 'aps20') &&
                (this.$scope.inputData.os === 'windows' || this.$scope.inputData.os === 'osx')) ||
                (this.licenses.length === 1 &&
                (this.$scope.inputData.os === 'windows' || this.$scope.inputData.os === 'osx')) ||
                ((this.$scope.inputData.os === 'android' || this.$scope.inputData.os === 'ios') &&
                this.allPaidApps.length === 1 && this.licenses.length === 1)
            ) {

                setTimeout(() => {

                    angular.element('.deploy-modal .deploy-steps div:nth-child(2)').addClass('disabled');

                    let deployPage = 'root.dashboard.devices.ltb.deploy';

                    if (this.$state.current.name.indexOf('.home') > -1) {

                        deployPage = 'root.dashboard.home.ltb.deploy';

                    } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

                        deployPage = 'root.dashboard.subscriptions.ltb.deploy';

                    }

                    this.$scope.changeWizard()(deployPage, {
                        appId,
                        os: this.$scope.inputData.os,
                        ltb: 'deploy',
                        resourceId: 'new',
                    }, {
                        reload: false,
                    });

                }, 0);

            }

        });

        /*
        // check if a bundle with 'Antivirus' name exists
        let antivirusBundleNameExists =
            this.allPaidApps.findIndex(
                (app) => app.oeName === 'Antivirus' && app.type === 'bundle') !== -1;

        // if a bundle with 'Antivirus'
        // name exists, remove all standalone apps that have 'Antivirus' name
        if (antivirusBundleNameExists) {

            this.allPaidApps.forEach((app, index) => {

                if ((app.type === 'app' || app.type === 'apps') && app.oeName === 'Antivirus') {

                    delete this.allPaidApps[index];
                }
            });
        }
        */

        // if there are no paid apps, show default app for the selected OS
        if (!this.allPaidApps.length) {

            const paramsWithDefaultApp = angular.extend({}, this.$state.params, {
                appId: CWCONFIG.defaultDeployedAppId[$scope.inputData.os],
                os: $scope.inputData.os,
            });

            setTimeout(() => {

                if (this.$state.current.name.indexOf('.home') > -1) {

                    this.$scope.changeWizard()('root.dashboard.home.ltb.deploy', paramsWithDefaultApp, {
                        reload: false,
                    });

                } else {

                    this.$scope.changeWizard()('root.dashboard.devices.ltb.deploy', paramsWithDefaultApp, {
                        reload: false,
                    });

                }

            }, 0);

        }

    }

    selectApp(appId, event, appName) {

        /**
         * Mobile users will install the mobile components from their app stores:
         *
         * Google Play for Android users
         * App Store for ios users
         */

        Mixpanel.send(
            'ConnectWeb Select License',
            {
                License: appName,
                'Device Os': window.deviceOs,
                Page: this.page,
                'Product ID': appId,
            },
        );

        if ((this.Util.getDeviceNavigator() === 'android' && this.$scope.inputData.os === 'android') ||
            (this.Util.getDeviceNavigator() === 'ios' && this.$scope.inputData.os === 'ios')) {

            // disable button until backend responds
            angular.element(event.target).addClass('disabled');

            let isBeta = false;

            if (this.componentsUsefulInfo[appId] && this.componentsUsefulInfo[appId].is_beta_otc) {

                isBeta = this.componentsUsefulInfo[appId].is_beta_otc;

            }

            const deploymentPayload = {
                appId,
                beta: isBeta,
                os: this.$scope.inputData.os,
            };

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then((response) => {

                // enable button
                angular.element(event.target).removeClass('disabled');

                // redirect user to app store
                this.$window.location.href = response.data.data.attributes.download_url;

            }).catch(() => {

                // enable button
                angular.element(event.target).removeClass('disabled');

                Alert.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-pc',
                    },
                });

            });

        } else {

            let deployPage = 'root.dashboard.devices.ltb.deploy';

            if (this.$state.current.name.indexOf('.home') > -1) {

                deployPage = 'root.dashboard.home.ltb.deploy';

            } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

                deployPage = 'root.dashboard.subscriptions.ltb.deploy';

            }

            this.$scope.changeWizard()(deployPage, {
                appId,
                os: this.$scope.inputData.os,
                ltb: 'deploy',
                resourceId: 'new',
            }, {
                reload: false,
            });

        }

    }

}


class PaidDeploymentWizardDirective {

    constructor() {

        this.template = require('./paid-deployment-wizard.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, $state, $window, Util, DeploymentUrlsRestService) =>
            new PaidDeploymentWizardController(
                $scope, $state, $window,
                Util, DeploymentUrlsRestService,
            ));

        this.controller = _controllerDependencies;
        this.controllerAs = 'paidDeploymentWizardCtrl';

    }

}

_directiveDependencies.push(() =>
    new PaidDeploymentWizardDirective());

angular.module('directives')
    .directive('paidDeploymentWizard', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/paid-deployment-wizard/paid-deployment-wizard.js